import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Classes from "@/pages/Classes";
import Pricing from "@/pages/Pricing";
import Private from "@/pages/Private";
import PrivateIntake from "@/pages/PrivateIntake";
import Staff from "@/pages/Staff";
import GiftCards from "@/pages/GiftCards";
import TestBsportMemberships from "@/pages/TestBsportMemberships";
import Corporate from "@/pages/Corporate";
import Schedule from "@/pages/Schedule";
import Events from "@/pages/Events";
import FAQ from "@/pages/FAQ";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/LegalPage";
import NewsletterWeek44En from "@/pages/NewsletterWeek44En";
import IntroMail from "@/pages/IntroMail";
import Signature from "@/pages/Signature";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/classes" element={<Classes />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/private" element={<Private />} />
            <Route path="/private-intake" element={<PrivateIntake />} />
            <Route path="/staff" element={<Staff />} />
            <Route path="/gift-cards" element={<GiftCards />} />
            <Route path="/test-bsport-memberships" element={<TestBsportMemberships />} />
            <Route path="/corporate" element={<Corporate />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/events" element={<Events />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<LegalPage kind="privacy" />} />
            <Route path="/terms" element={<LegalPage kind="terms" />} />
            <Route path="/cookies" element={<LegalPage kind="cookies" />} />
            <Route path="/newsletter/week-44-en" element={<NewsletterWeek44En />} />
            <Route path="/intro/:slug" element={<IntroMail />} />
            <Route path="/signature" element={<Signature />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
